import React, { useContext } from 'react'
import { PostPurchaseDispatchContext } from '../context/PostPurchaseContext';

function Popup({ popupTitle, message, imageSrc,setShowPopup, extraClasses, actionBtns, onClose }) {
    const dispatch = useContext(PostPurchaseDispatchContext);

    function handleYes() {
        dispatch({ type: "setActiveStep", payload: 4 })
    }
    
    function handleNo() {
        setShowPopup(false)
    }

    return (
        <div className="fixed inset-0 bg-muted-400 z-50 bg-opacity-50 flex items-center justify-center px-6">
            <div className={`text-white rounded-3xl py-12 px-14 text-[19px] text-left shadow-[0_6px_12px_rgb(0_0_0_/_0.5)] lg:max-w-[600px] lg:m-auto ${extraClasses}`}>
                <div className='flex flex-row-reverse'>
                    {onClose && <button className="flex" onClick={onClose}><img className="w-11 h-11" src="data:image/svg+xml,%3Csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23FFFFFF;stroke-linecap:round;stroke-linejoin:round;%7D
    %3C/style%3E%3Cpath class='st0' d='M20,4L4,20'/%3E%3Cpath class='st0' d='M4,4l16,16'/%3E%3C/svg%3E" alt='close-button'/></button>}
                    <p className='font-semibold underline pb-5 w-full'>{popupTitle}</p>
                </div>
                <p className='font-normal'>{message}</p>
                <img className='pt-8' src={imageSrc} />
                {actionBtns && <div className="grid grid-cols-2 gap-6 justify-center items-center font-bold mt-6">
                    <button onClick={handleNo} className="bg-brio-300 rounded-3xl py-7 ">Go Back</button>
                    <button onClick={handleYes} className="bg-brio-300 rounded-3xl py-7 ">Continue</button>
                </div>}
            </div>
        </div>
    )
}

export default Popup